import { baseApi } from '@/config/axios';
import { SendGpsApiParams, SendGpsApiResponse } from '@/types/api/trouble';

//GPS情報送信
export const sendGpsApi = (
  params: SendGpsApiParams,
): Promise<SendGpsApiResponse> => baseApi.post('v1/customer/gps', params);
